import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './az-w4.component.html';
import moment from 'moment';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';

export const AZW4Component = {
    templateUrl,
    controller: AZw4Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        showSignaturePopup: "<",
        close: "&",
        dismiss: "&"
    }
};

function AZw4Controller(onboardingActionPolicy, onboardingDocumentService, $state, $scope, $uibModal, $q, utilityService, localeService, onboardingDocumentViewService, employeeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('2', vm.application) === 'View';

    vm.taxForm;

    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onDocDownload = onDocDownload;
    vm.onSubmit = onSubmit;
    vm.onShowI9 = onShowI9;
    vm.onClose = onClose;
    vm.onShowFederalW4 = onShowFederalW4;
    vm.onRequestReview = onRequestReview;
    vm.onSave = onSave;
    vm.revealSSNChar = revealSSNChar;
    vm.revealFEINChar = revealFEINChar;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.ssnIsValidated = ssnIsValidated;
    vm.changeLiability = changeLiability;
    vm.onEditClicked = onEditClicked;
    vm.ssnBlur = ssnBlur;

    vm.reqReview = false;
    vm.isSaved = false;
    vm.isSigned = false;
    vm.prefilled = false;
    vm.disableEmpFields = true;
    vm.showSavedNotification = false;
    vm.editable = true;
    vm.savedData = false;
    vm.previewUrl;
    vm.state = {
        view: 'W4'
    };

    vm.$onInit = function () {
        console.log(vm.resolve);
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.reqReview = false;
        vm.date = moment(new Date(), 'DD/MM/YYYY').toDate();
        vm.stateProvinces = this.provinces;
        vm.userProfile = this.profile;

        vm.retrieveLocale()
            .then(function (locale) {
                console.log(locale);
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;

            });
        //if (this.application) {
        //    vm.editable = !(vm.application && vm.application.ProvinceW4DocumentId != null);
        //}
        if (vm.savedInputs != null && vm.savedInputs.EmployeeFirstNameMiddleInitialLastName != null && !vm.ownerView) {
            console.log(vm.savedInputs);
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
            //default to user profile
            vm.employeeName = vm.employeeProfile.FullName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = vm.profile.HomeAddress?.StreetLine1;
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        } else if (vm.userInputs != null && vm.userInputs.EmployeeFirstNameMiddleInitialLastName != null) {
            //prefill this.userInputs
            if (this.application) {
                vm.editable = !(this.application && this.application.HasSW4Form !== null && this.application.ProvinceW4 !== 'Review' && this.application.ProvinceW4 !== 'Submitted' && this.application.ProvinceW4 !== 'Pending');
            }
            fillEmployee(vm.userInputs);
        } else {
            //prefill user info
            //vm.taxForm.$setDirty();
            vm.employeeName = vm.employeeProfile.FullName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = vm.profile.HomeAddress?.StreetLine1;
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        }
        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }

        if (vm.ownerView && vm.showSignaturePopup) {
            return onPreview();
        }
        vm.editable = resolveEditable();
    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.ProvinceW4;  // ? ProvinceW4

        // ReviewRequired: always directly editable so the employee can fix it
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        // Submitted or Approved form: locked so the Edit button shows
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            // Active employees: skip edit button, directly editable
            // Pending employees (new hire): start locked so edit button is shown
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }

        return !vm.application.HasSW4Form              // ? HasSW4Form
            || formStatus === 'Pending'
            || formStatus === 'ReviewRequired';
    }


    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending') {
            vm.employeeName = vm.employeeProfile.FullName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = vm.profile.HomeAddress?.StreetLine1;
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);

            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        }
    }

    //event to track if user changed any form data
    $scope.$watch('vm.taxForm.$dirty', function (value) {
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    //function onSign() {
    //    return $uibModal.open({
    //        ...SignaturePadModal,
    //        resolve: {
    //            title: () => "Changes to Time Entry"
    //        }
    //    }).result.then(function (data) {
    //        vm.signimage = data;
    //    });
    //}


    function changeLiability() {
        if (!vm.taxLiability) {
            vm.percentState = null;
            vm.additionalStateWithholding = null;
        }
    }

    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '2');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );
    }

    function onShowI9() {
        vm.close({ $value: 'ok' });
    }

    function onShowFederalW4() {
        if (vm.ownerView) {
            return $state.go('application-status.ownermodal.federalW4');
        }
        //warning for pending changes
        if (vm.taxForm && vm.taxForm.$dirty) {
            return $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "onboarding-document.federalW4";
                    }
                },
                size: 'sm',
                backdrop: 'static'
            }).result
        }
        return $state.go('onboarding-document.federalW4');
    }

    //capture esc key press
    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.arW4Form && vm.arW4Form.$dirty) {
            /* vm.close({ $value: 'cancel' });*/
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "application-status";
                    }
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }

    function fillEmployee(data) {
        vm.employeeName = data.EmployeeFirstNameMiddleInitialLastName;
        vm.employeeSsn = data.EmployeeSocialSecurityNumber;
        vm.address = data.EmployeeStreetAddress1StreetAddress2;
        vm.city = data.EmployeeCity;
        vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.employeeBankInfo?.StateToBeTaxedIn);
        vm.zipCode = data.EmployeeZip;
        //vm.taxLiability = data.NoTaxLiability == true;
        vm.percentState = data.PercentState;
        vm.additionalStateWithholding = vm.additionalStateWithholding != null ? Number(vm.additionalStateWithholding) : 0
        //vm.additionalStateWithholdingCheckbox = data.AdditionalStateWithholding != null;
        if (data.TaxLiability) {
            vm.taxLiability = 'true';
        } else if (data.NoTaxLiability) {
            vm.noTaxLiability = 'false';
        }
        if (data.Signature) {
            vm.signimage = data.Signature;
            vm.isSigned = true;

        }
        vm.prefilled = true;
        vm.date = moment(data.Date, 'DD/MM/YYYY').toDate();
    }

    //function syncFormToProfile() {
    //    //find a way to update full name
    //    vm.profile.HomeAddress.StreetLine1 = vm.address;
    //    vm.profile.HomeAddress.City = vm.city;
    //    //vm.employeeBankInfo.StateToBeTaxedIn = vm.stateProvince.StateProvinceID;
    //}


    function onDocDownload(pages) {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', '5', pages).then(function (result) {
            utilityService.hideLoading();
            return result;
        }).then(function () {
            utilityService.hideLoading();
        });

    }

    function onPreview() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            EmployeeFirstNameMiddleInitialLastName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetaddress1Streetaddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.stateProvince.Abbr,
            EmployeeZip: vm.zipCode,
            TaxLiability: vm.taxLiability,
            PercentState: vm.percentState,
            AdditionalWithHoldingCheckbox: vm.additionalStateWithholding != null,
            AdditionalStateWithholding: vm.additionalStateWithholding != null ? Number(vm.additionalStateWithholding) : 0,
            NoTaxLiability: !vm.taxLiability,
            Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
            Signature: vm.signimage,
        };

        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, 5)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...OwnerPreviewSignatureModal,
                    resolve: {
                        title: () => "Federal-W4 Preview",
                        previewUrl: () => {
                            return vm.previewUrl;
                        },
                        allowApprove: () => {
                            return canApproveForm(vm.application, '2');
                        },
                        allowSign: () => {
                            return false;
                        }, //for pages without signature
                        showSignaturePopup: () => {
                            return vm.showSignaturePopup;
                        }
                    }
                }).result
            }).then(function (data) {
                console.log(data);
                if (data === 'terminate' && vm.showSignaturePopup) {
                    return vm.close({ $value: 'ok' });
                }
                if (data === 'ok') {
                    vm.employerSignimage = data.dataUrl;
                    vm.isSigned = true; //employer version
                    return onSubmit();
                }
            }).catch((err) => {
                console.log(err);
                utilityService.hideLoading();
            });
        //return onboardingDocumentService.preview(vm.employee.UserName,
        //    {
        //        RequestTypeId: '2',
        //        IsI9EmployeeMode: !vm.ownerView,
        //        EmployeeFirstNameMiddleInitialLastName: vm.employeeName,
        //        EmployeeSocialSecurityNumber: vm.employeeSsn,
        //        EmployeeStreetaddress1Streetaddress2: vm.address,
        //        EmployeeCity: vm.city,
        //        EmployeeState: vm.stateProvince.Abbr,
        //        EmployeeZip: vm.zipCode,
        //        TaxLiability: vm.taxLiability,
        //        PercentState: vm.percentState,
        //        AdditionalWithHoldingCheckbox: vm.additionalStateWithholding != null,
        //        AdditionalStateWithholding: vm.additionalStateWithholding,
        //        NoTaxLiability: !vm.taxLiability,
        //        Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
        //        Signature: vm.signimage,
        //    }, 5)
        //    .then(function (result) {
        //        utilityService.hideLoading();
        //        vm.ISPreview = true;
        //        return result;
        //    }).then(function () {
        //        utilityService.hideLoading();
        //    });

    }

    function onPreviewInPage() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            EmployeeFirstNameMiddleInitialLastName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetaddress1Streetaddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.stateProvince.Abbr,
            EmployeeZip: vm.zipCode,
            TaxLiability: vm.taxLiability,
            PercentState: vm.percentState,
            AdditionalWithHoldingCheckbox: vm.additionalStateWithholding != null,
            AdditionalStateWithholding: vm.additionalStateWithholding != null ? Number(vm.additionalStateWithholding) : 0,
            NoTaxLiability: !vm.taxLiability,
            Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
            //Signature: vm.signimage,
        };
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, 5)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...PreviewSignatureModal,
                    resolve: {
                        title: () => "Federal-W4 Preview",
                        previewUrl: () => {
                            return vm.previewUrl;
                        }
                    }
                }).result
            }).then(function (data) {
                console.log(data);
                vm.signimage = data.dataUrl;
                vm.isSigned = data.dataUrl != null;
                //vm.ISPreview = true;
                return onSubmit();
            }).catch((err) => {
                console.log(err);
                utilityService.hideLoading();
            });

    }

    function onSave() {
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            EmployeeFirstNameMiddleInitialLastName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetaddress1Streetaddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.stateProvince.Abbr,
            EmployeeZip: vm.zipCode,
            TaxLiability: vm.taxLiability === 'true' ? 'true' : 'false',
            PercentState: vm.percentState,
            AdditionalWithHoldingCheckbox: vm.additionalStateWithholding != null,
            AdditionalStateWithholding: vm.additionalStateWithholding != null ? Number(vm.additionalStateWithholding) : 0,
            NoTaxLiability: vm.taxLiability === 'false' ? 'true' : 'false',
            Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
            Signature: vm.signimage,
        };
        return onboardingDocumentService.save(vm.employee.UserName, formData, 5).then(function () {
            vm.isSaved = true;
            vm.showSavedNotification = true;
            vm.arW4Form.$setPristine();
            return utilityService.hideLoading();
        });
    }


    function onApprove() {
        let approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "2");
        const trans = $q.all(approvePromise).then((res) => {
            if (res) {
                vm.onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Approve failed")
        );
    }

    function onSubmit() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return utilityService.hideLoading();
        }
        let promiseArray = [];
        let submitApplicationPromise = $q.defer();
        vm.isDirtyEdit = vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending' && (vm.application.ProvinceW4 === 'Approved' || vm.application.ProvinceW4 === 'Pending');
        if ((vm.taxForm && vm.taxForm.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isDirtyEdit || isPendingResubmit || vm.isSigned || vm.application.ProvinceW4 === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading();
                alert("Preview and Signature are required");
            }
            if (!vm.signimage) {
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }
            let formData = {
                RequestTypeId: '2',
                IsI9EmployeeMode: !vm.ownerView,
                EmployeeFirstNameMiddleInitialLastName: vm.employeeName,
                EmployeeSocialSecurityNumber: vm.employeeSsn,
                EmployeeStreetaddress1Streetaddress2: vm.address,
                EmployeeCity: vm.city,
                EmployeeState: vm.stateProvince.Abbr,
                EmployeeZip: vm.zipCode,
                TaxLiability: vm.taxLiability === 'true' ? 'true' : 'false',
                PercentState: vm.percentState,
                AdditionalWithHoldingCheckbox: vm.additionalStateWithholding != null,
                AdditionalStateWithholding: vm.additionalStateWithholding != null ? Number(vm.additionalStateWithholding) : 0,
                NoTaxLiability: vm.taxLiability === 'false' ? 'true' : 'false',
                Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
                Signature: vm.signimage,
            };
            submitApplicationPromise = onboardingDocumentService.submit(vm.employee.UserName, formData, 5)
            promiseArray.push(submitApplicationPromise);
        }
        if (!Array.isArray(promiseArray) || promiseArray.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }

        }

        const trans = $q.all(promiseArray).then((res) => {
            if (res) {
                if (vm.ownerView) {
                    return onApprove();
                } else {
                    return onShowI9();
                }
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
    }


    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                return translations;
            });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                console.log(vm.employeeBankInfo.CountryID);
                return locales.filter(function (locale) {
                    console.log(vm.employeeBankInfo.CountryID);
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function ssnIsValidated() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.ssnChanged) {
            if ((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) {
                return false;
            }
        }
        return true;
    }

    function ssnBlur() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.SSN !== vm.employeeBankInfo.originalSSN) {
            vm.employeeBankInfo.ssnChanged = true;
        } else {
            vm.employeeBankInfo.ssnChanged = false;
        }
    }

    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
    function revealFEINChar(fein, char, i) {
        return i > 4;
    }
}


export const AZW4Modal = {
    component: "apexAZW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}

